import { useEffect, useState } from "react";
import { Icon, type IconName } from "../icons/Icon";
import { registerToastSink, type ToastItem, type ToastKind } from "./toast-service";
import "../../styles/components/toast.css";

const ICON_BY_KIND: Record<ToastKind, IconName> = {
  success: "check-circle",
  error: "close-circle",
  info: "info",
  warning: "warning",
};

/** 挂载在应用根部（App.tsx）：唯一渲染提示的地方。提示内容由 toast-service 推送。 */
export default function ToastHost() {
  const [items, setItems] = useState<ToastItem[]>([]);

  useEffect(() => {
    const timers = new Map<number, number>();

    registerToastSink((item) => {
      // 最多同时 5 条，超出挤掉最早的，避免刷屏遮挡操作区
      setItems((prev) => [...prev.slice(-4), item]);
      if (item.duration > 0) {
        const timer = window.setTimeout(() => {
          setItems((prev) => prev.filter((x) => x.id !== item.id));
          timers.delete(item.id);
        }, item.duration);
        timers.set(item.id, timer);
      }
    });

    return () => {
      registerToastSink(null);
      timers.forEach((timer) => window.clearTimeout(timer));
      timers.clear();
    };
  }, []);

  const dismiss = (id: number) => setItems((prev) => prev.filter((x) => x.id !== id));

  return (
    <div className="toast-host" role="status" aria-live="polite">
      {items.map((item) => (
        <div key={item.id} className={`toast toast-${item.kind}`}>
          <Icon name={ICON_BY_KIND[item.kind]} size={16} />
          <span className="toast-text">{item.text}</span>
          {item.action ? (
            <button
              type="button"
              className="toast-action"
              onClick={() => {
                item.action?.onClick();
                dismiss(item.id);
              }}
            >
              {item.action.label}
            </button>
          ) : null}
          <button type="button" className="toast-close" aria-label="关闭提示" onClick={() => dismiss(item.id)}>
            <Icon name="close" size={13} />
          </button>
        </div>
      ))}
    </div>
  );
}
